import TemplateView from '../../../../TemplateView'
import LeaveRatesEditor from '../../../../administration/userManagement/ratesEditor/LeaveRatesEditor'
import messageResource from '../../../../messageResource'
import {isLeaveRatesEmpty} from './validationUtils'
import FloatNumberValidator from '../../../../administration/userManagement/ratesEditor/FloatNumberValidator'
import NumberFormatter from '../../../../number_formatter'
import {MAX_RATE} from 'constants'
import {getInstance as getModalAlert} from '../../UserPanelModalAlert'
import {ModalAlertPointerPosition} from '../../../../components/modalAlert/constants'
import {UserRatesErrors} from './constants'

const numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

export default class LeaveRatesCell extends TemplateView {
    constructor({
        readOnly = false,
        scrollTo = () => {},
        activeLeaveTypes,
        onChangeCb = () => {},
        rollbackChanges = () => {},
        subscribeSelectorOnScroll = () => {},
        leaveRatesMenu,
    }) {
        super()

        this.activeLeaveTypes = activeLeaveTypes

        this.params = {
            readOnly,
            scrollTo,
            leaveRatesMenu,
        }

        this.callbacks = {
            onChangeCb,
            rollbackChanges,
            subscribeSelectorOnScroll,
        }

        this.state = {
            regularRate: null,
            leaveRates: [],
            isEmptyValid: false,
            error: null,
            needShowWarning: false,
        }

        this.onAnyStatePropertyChanged(['regularRate', 'leaveRates', 'isEmptyValid'], state => {
            this._updateView(state.leaveRates, state.regularRate, state.isEmptyValid)
        })
        this.onStatePropertyChanged('error', error => this._updateLeaveRatesText(this.state.leaveRates, error))
        this.onStatePropertyBecameTrue('needShowWarning', () => this._showWarning(this.state.error))
    }

    templateHtml() {
        return '<div class="leaveRatesCell">' +
               '    <div class="leaveRatesEditorPlaceholder"/>' +
               '    <div class="leaveRatesLabel"/>' +
               '</div>'
    }

    templateModel() {
        return {
            placeholder: `0${window.SystemSettings.decimalSeparator}00`
        }
    }

    afterRender() {
        this.$leavesEditor = this.find('.leaveRatesEditorPlaceholder')
        this.$leavesRatesLabel = this.find('.leaveRatesLabel')
    }

    _updateView(leaveRates, regularRate, isEmptyValid) {
        if (!this.params.readOnly) {
            this._updateLeavesEditor(leaveRates, regularRate, isEmptyValid)
        } else {
            this.$leavesEditor.empty()
        }
    }

    _updateLeavesEditor(leaveRates, regularRate, isEmptyValid) {
        this.$leavesEditor.empty()
        this.$leavesRatesLabel.hide()

        this.leaveRatesEditor = new LeaveRatesEditor({
            menu: this.params.leaveRatesMenu,
            renderTo: this.$leavesEditor[0],
            value: leaveRates,
            menuAlign: "br-tr"
        })

        this.leaveRatesEditor.on("menushow", () => {
            this.getEl().toggleClass('leavesEditorOpened', true)
            this.leaveRatesEditor.menu.setUp(leaveRates, regularRate, isEmptyValid && this.state.error === null)
        })

        this.leaveRatesEditor.on("menuhide", () => {
            this.getEl().toggleClass('leavesEditorOpened', false)
        })

        this.leaveRatesEditor.on("change", leaveRates => this._handleRatesChanged(leaveRates))

        this._updateLeaveRatesText(leaveRates, this.state.error)
    }

    _updateLeaveRatesText(leaveRates, error) {
        const isEmpty = isLeaveRatesEmpty(leaveRates)
        this.getEl().toggleClass('empty', isEmpty)

        if (isEmpty) {
            this._setLeavesRatesText(messageResource.getMessage("user.add_edit.js.rates_editor.leave_rates.not_defined"), error === UserRatesErrors.RATE_EMPTY)
        } else if (error === UserRatesErrors.RATE_INVALID) {
            this._setLeavesRatesText(messageResource.getMessage("user.add_edit.js.rates_editor.leave_rates.invalid"), true)
        } else {
            const rates = leaveRates.map(lr => FloatNumberValidator.getInstance().parseFloat(lr.rate))
            const minRate = Math.min(...rates)
            const maxRate = Math.max(...rates)

            if (minRate === maxRate)
                this._setLeavesRatesText(numberFormatter.format(minRate), false)
            else
                this._setLeavesRatesText(numberFormatter.format(minRate) + " - " + numberFormatter.format(maxRate), false)
        }
    }

    _setLeavesRatesText(text, invalid) {
        if (this.params.readOnly) {
            this.$leavesRatesLabel.text(text)
        } else {
            this.leaveRatesEditor.setText(text)
            this.getEl().toggleClass('invalid', invalid)
        }
    }

    _handleRatesChanged(leaveRates) {
        const normalizedRates = leaveRates.map(leaveRate => {
            return {
                ...leaveRate,
                rate: numberFormatter.normalize(leaveRate.rate),
            }
        })
        this.callbacks.onChangeCb(normalizedRates)
    }

    _showWarning(error) {
        let msg = error === UserRatesErrors.RATE_EMPTY ? messageResource.getMessage('user.add_edit.js.rates_editor.empty_rate')
            : messageResource.getMessage('user.add_edit.js.rates_editor.invalid_rate', [MAX_RATE])
        msg = msg + '\n' + messageResource.getMessage('rates.editor.modifications_will_be_discarded')

        this.params.scrollTo(this.getEl())

        getModalAlert().setState({
            text: msg,
            pointerPosition: ModalAlertPointerPosition.RIGHT
        }).showAt(this.getEl(), () => {
            this.callbacks.rollbackChanges()
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/LeaveRatesCell.js